module.exports = __webpack_public_path__ + "static/media/plaque_vosges22.6dc4e14a.png";